<app-page [showPostButton]="true">
  <creator-profile-details></creator-profile-details>
</app-page>
